export const BusinessSteps = [
  {
    id: 1,
    title: 'התחברות',
    description: 'צור חשבון חדש במערכת'
  },
  {
    id: 2,
    title: 'פרטי עסק',
    description: 'הזן את פרטי העסק שלך'
  },
  {
    id: 3,
    title: 'שעות פעילות',
    description: 'הגדר את שעות הפעילות של העסק'
  },
  {
    id: 4,
    title: 'שירותים',
    description: 'הוסף את השירותים שהעסק מציע'
  },
  {
    id: 5,
    title: 'בחירת מסלול',
    description: ''
  }
];

export { BusinessStepOne } from './BusinessStepOne';
export { BusinessStepTwo } from './BusinessStepTwo';
export { BusinessStepThree } from './BusinessStepThree';
export { BusinessStepFour } from './BusinessStepFour';
export { BusinessStepFive } from './BusinessStepFive';